import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.ErrorScreen', {
    disconnectionWarningText:
        'The matrix is not available since the organisation is disconnected from {integrationName}',
});
